import React, { Component } from 'react';
import PropTypes from 'react-proptypes';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Icon from 'src/components/icon';

import './dropdown.scss';

class Dropdown extends Component {

    static propTypes = {
        label: PropTypes.string,
        selected: PropTypes.object,
        onChange: PropTypes.func,
        onIgnore: PropTypes.func,
        options: PropTypes.object,
        index: PropTypes.number,
    };

    static defaultProps = {
        label: '',
        selected: null,
        onChange: () => {},
        onIgnore: () => {},
        options: [],
        index: 1,
    };

    constructor(props) {
        super(props);

        // Keep groups opened on mount
        const openedGroups = [];

        this.state = {
            opened: false,
            openedGroups,
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        const isClickInside = this.dropdown.contains(e.target);

        if (!isClickInside) {
            this.setState({ opened: false });
        }
    };

    handleToggleDropdown = () => {
        const { opened } = this.state;
        if (opened) {
            this.closeDropdown();
        } else {
            this.openDropdown();
        }
    };

    handleToggleGroup = (groupId) => {
        const { openedGroups } = this.state;
        const index = openedGroups.indexOf(groupId);
        if (index !== -1) {
            openedGroups.splice(index, 1);
        } else {
            openedGroups.push(groupId);
        }

        this.setState({ openedGroups });
    };

    handleSelectField = (groupIndex, itemIndex) => {
        const {
            onChange, options, selected, label, index,
        } = this.props;

        const newFieldGroup = options[groupIndex];
        const newField = options[groupIndex].fields[itemIndex];

        const newFieldParsed = {
            headerLabel: label,
            mappedFieldLabel: newField.name,
            mappedGroupName: newFieldGroup.name,
            mappedFieldName: newField.mappedName,
            multiple: newField.multiple,
            mandatory: newField.mandatory,
        };

        onChange(selected, newFieldParsed, index)
            .then(() => {
                this.setState({
                    openedGroups: [],
                    opened: false,
                });
            }).catch(() => {});
    };

    handleRemoveField = () => {
        const { selected, onChange, index } = this.props;
        onChange(selected, null, index);
    };

    openDropdown = () => {
        setTimeout(() => {
            this.setState({ opened: true });
        }, 0);
    }

    closeDropdown = () => {
        setTimeout(() => {
            this.setState({ opened: false });
        }, 0);
    }

    render() {
        const {
            label,
            options,
            selected,
            onIgnore,
            index,
        } = this.props;

        const {
            opened,
            openedGroups,
        } = this.state;

        return (
            <div
                ref={(obj) => { this.dropdown = obj; }}
                className={classnames(
                    'Dropdown',
                    { opened },
                    { 'option-selected': selected },
                )}
            >
                <div className="wrapper">
                    <select name="nome-coluna" style={{ display: 'none' }} />
                    <div
                        className="top"
                        onClick={!selected ? this.handleToggleDropdown : null}
                    >
                        <div className="left">
                            {!selected ? (
                                [
                                    <label>Coluna</label>,
                                    <div className="placeholder">{label}</div>,
                                ]
                            ) : (
                                <div className="selected-option">
                                    {selected.mappedFieldLabel}
                                </div>
                            )}
                        </div>
                        <div className="right">
                            {!selected ? (
                                <Icon
                                    code={opened ? 'angle-up' : 'angle-down'}
                                    size={18}
                                    color="white"
                                />
                            ) : (
                                <Icon
                                    code="times"
                                    size={14}
                                    color="white"
                                    onClick={this.handleRemoveField}
                                />
                            )}
                        </div>
                    </div>
                    <div className="values">
                        {options.length && (
                            <ul>
                                {options.map((group, index) => (
                                    <li
                                        className={classnames('group', { opened: openedGroups.indexOf(index) !== -1 })}
                                        key={index}
                                    >
                                        <div className="group-name" onClick={() => this.handleToggleGroup(index)}>
                                            <Icon code={openedGroups.indexOf(index) !== -1 ? 'angle-down' : 'angle-right'} color="#7740f9" size={18} />
                                            {group.name}
                                        </div>
                                        <ul className="group-items">
                                            {group.fields.map((field, i) => (
                                                <li className="item" key={i}>
                                                    <div
                                                        onClick={() => this.handleSelectField(index, i)}
                                                        data-tip={field.description}
                                                    >
                                                        {field.name}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                ))}
                            </ul>
                        )}
                        <div
                            className="ignore-column"
                            onClick={() => {
                                onIgnore(index);
                            }}
                        >
                            Ignorar coluna
                        </div>
                    </div>
                </div>

                {/* Tooltip Component */}
                <ReactTooltip
                    place="right"
                    effect="solid"
                    multiline
                />

            </div>
        );
    }

}

export default Dropdown;
